export const clarivoyEvents = {
  ClarivoyLoaded: 'ClarivoyLoaded',
}

export type ClarivoyData = {
  isScriptLoadable: boolean
}
